import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zh from './locales/zh.json';
import en from './locales/en.json';
import id from './locales/id.json';
import { normalizeAdminLanguage, SUPPORTED_ADMIN_LANGUAGES } from './utils/language';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en },
      id: { translation: id }
    },
    fallbackLng: 'id',
    supportedLngs: SUPPORTED_ADMIN_LANGUAGES,
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',
      convertDetectedLanguage: normalizeAdminLanguage
    },
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (language) => {
  const normalizedLanguage = normalizeAdminLanguage(language);

  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalizedLanguage;
  }

  if (typeof window !== 'undefined') {
    window.localStorage.setItem('i18nextLng', normalizedLanguage);
  }
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = normalizeAdminLanguage(i18n.resolvedLanguage || i18n.language);
}

export default i18n;
